<template>
    <div class="subtitlePage">
        <router-link :to="'/index'" class="linkLine" >
            首页 <i class="el-icon-arrow-right"></i>
        </router-link>
        <div v-for="(value , key) in subtitleData">
            <router-link :to="value.link" class="linkLine" :class=" { active : subtitleData.length == key + 1 }">
                {{value.name}} <i v-if="subtitleData.length > key + 1" class="el-icon-arrow-right"></i>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            
        }
    },
    props:[
        "subtitleData"
    ],
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>
    .subtitlePage{
        position: fixed;
        top:68px;
        left: 180px;
        height: 46px;
        padding-left: 12px;
        background: #fff;
        width: 100%;
        border-bottom: 1px solid #eee;
        z-index: 9;

        .linkLine{
            height: 46px;
            line-height: 46px;
            display: block;
            float: left;
            color:#989898;

            &.active{
                color:#282828;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/basics/subtitle.vue